"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var constants_1 = require("utils/constants");
var BidSelector = function (props) {
    var onChangeTimer;
    var _a = React.useState(null), searchString = _a[0], setSearchString = _a[1];
    var _b = React.useState(false), focus = _b[0], setFocus = _b[1];
    return (React.createElement(sok_ui_1.Dropdown2, { className: 'bid-selector', isOpen: focus, onChange: function (status, e) {
            var elem = e.target;
            while (elem) {
                if (elem.classList.contains('bid-search-input')) {
                    return;
                }
                elem = elem.parentElement;
            }
            setFocus(status);
        } },
        React.createElement(sok_ui_1.TextInput, { className: 'bid-search-input', value: searchString !== null
                ? searchString
                : props.value
                    ? props.value.name
                    : '', onFocus: function () {
                if (props.value) {
                    setSearchString(props.value.name);
                }
                setFocus(true);
            }, onBlur: function () {
                if (props.value !== null) {
                    setSearchString(props.value.name);
                }
            }, onChange: function (_a) {
                var value = _a.target.value;
                if (onChangeTimer) {
                    clearTimeout(onChangeTimer);
                }
                setSearchString(value);
                onChangeTimer = setTimeout(function () {
                    onChangeTimer = undefined;
                }, constants_1.SEARCH_TIMEOUT);
            }, iconRight: React.createElement("span", { className: 'icons' },
                props.value && (React.createElement(sok_ui_1.Icon, { className: 'fa-times', onClick: function () {
                        props.onSelect(null);
                        setSearchString(null);
                    } })),
                React.createElement(sok_ui_1.Icon, { onClick: function () { return setFocus(!focus); }, className: 'fa-chevron-down' })) }),
        React.createElement(sok_ui_1.Dropdown2Menu, { className: 'activity-bid-selector' }, props.bids
            .filter(function (bid) {
            return bid.name
                .toLowerCase()
                .includes((searchString && searchString.toLocaleLowerCase()) || '');
        })
            .map(function (bid) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: 'bid-' + bid.id, className: props.value && props.value.id === bid.id ? 'selected' : '', onClick: function () {
                setSearchString(null);
                props.onSelect(bid);
            } }, bid.name)); }))));
};
exports.default = BidSelector;
